import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { CourseProgressionTypeSchema } from './course.schema.js';
extendZodWithOpenApi(z);
const uuidSchema = z.string().uuid('Invalid UUID format');
// ─── Param schemas ───────────────────────────────────────────────────────────
export const DraftModuleParamsSchema = z.object({
    courseId: uuidSchema,
    versionId: uuidSchema,
    moduleId: uuidSchema,
});
export const DraftTopicParamsSchema = z.object({
    courseId: uuidSchema,
    versionId: uuidSchema,
    topicId: uuidSchema,
});
export const DraftLessonParamsSchema = z.object({
    courseId: uuidSchema,
    versionId: uuidSchema,
    lessonId: uuidSchema,
});
// ─── Input schemas ──────────────────────────────────────────────────────────
export const AddDraftModuleSchema = z
    .object({
    title: z.string().min(1).max(200),
    description: z.string().max(1000).default(''),
})
    .openapi('AddDraftModule');
export const UpdateDraftModuleSchema = z
    .object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(1000).optional(),
})
    .openapi('UpdateDraftModule');
export const AddDraftTopicSchema = z
    .object({
    title: z.string().min(1).max(200),
    description: z.string().max(1000).default(''),
})
    .openapi('AddDraftTopic');
export const UpdateDraftTopicSchema = z
    .object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(1000).optional(),
})
    .openapi('UpdateDraftTopic');
export const AddDraftLessonSchema = z
    .object({
    sourceLessonId: uuidSchema.optional(),
    title: z.string().min(1).max(200).optional(),
})
    .openapi('AddDraftLesson');
export const ReorderDraftItemsSchema = z
    .object({
    orderedIds: z.array(uuidSchema).min(1),
})
    .openapi('ReorderDraftItems');
export const MoveDraftTopicSchema = z
    .object({
    targetModuleId: uuidSchema,
    position: z.number().int().min(0),
})
    .openapi('MoveDraftTopic');
export const MoveDraftLessonSchema = z
    .object({
    targetTopicId: uuidSchema,
    position: z.number().int().min(0),
})
    .openapi('MoveDraftLesson');
export const UpdateDraftMetadataSchema = z
    .object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(2000).nullable().optional(),
    iconUrl: z.string().nullable().optional(),
    headerImageUrl: z.string().nullable().optional(),
    accentColour: z.string().max(20).nullable().optional(),
    progressionType: CourseProgressionTypeSchema.optional(),
})
    .openapi('UpdateDraftMetadata');
//# sourceMappingURL=draft-structure.schema.js.map